import * as actionTypes from '../actions/actionTypes'

const initialState = {
  pagination: { total: 0, to: 0, lastPage: 1, from: 0, currentPage: 1, perPage: 10 },
  records: [],
  loading: false,
  selectedRecord: null,
  parentCompanies: [],
  passwordPolicies: [],
  ldapServers: [],
  emailServers: [],
  companies: [],
  filterPerspective: [],
  success: false,
  loadingStates: []
}

const fetchCompanyStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'company_id'] }
}

const fetchCompanySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    companies: action.data
  }
}

const fetchCompanyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    message: action.errorMessage
  }
}

const fetchPerspectiveFilerStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'perspective_id'] }
}

const fetchPerspectiveFilerSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    loadingStates: state.loadingStates.filter(item => item !== 'perspective_id'),
    filterPerspective: action.data
  }
}

const fetchPerspectiveFilerFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'perspective_id'),
    loading: false
  }
}

const fetchPerspectiveStart = (state, action) => {
  return { ...state, loading: true, loadingStates: [...state.loadingStates, 'record'] }
}

const fetchPerspectiveSuccess = (state, action) => {
  let { records, pagination } = action
  return {
    ...state,
    loading: false,
    pagination: pagination,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    records: records
  }
}

const fetchPerspectiveFailed = (state, action) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'record'),
    loading: false
  }
}

const fetchPerspectiveByIdSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    selectedRecord: action.recordData,
    loadingStates: state.loadingStates.filter(item => item !== 'record')
  }
}

const clearSelectedPerspectiveRecord = (state, action) => {
  return {
    ...state,
    selectedRecord: { is_active: true },
    success: false
  }
}

const createPerspectiveStart = (state, action) => {
  return { ...state, loading: true }
}

const createPerspectiveSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const createPerspectiveFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const updatePerspectiveStart = (state, action) => {
  return { ...state, loading: true }
}

const updatePerspectiveSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const updatePerspectiveFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const deletePerspectiveStart = (state, action) => {
  return { ...state, loading: true }
}

const deletePerspectiveSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    success: true
  }
}

const deletePerspectiveFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    success: false
  }
}

const fetchPasswordPolicyStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchPasswordPolicySuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    passwordPolicies: action.data
  }
}

const fetchPasswordPolicyFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchLdapServerStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchLdapServerSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    ldapServers: action.data
  }
}

const fetchLdapServerFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchEmailServerStart = (state, action) => {
  return { ...state, loading: true }
}

const fetchEmailServerSuccess = (state, action) => {
  return {
    ...state,
    loading: false,
    emailServers: action.data
  }
}

const fetchEmailServerFailed = (state, action) => {
  return {
    ...state,
    loading: false,
    message: action.errorMessage
  }
}

const fetchPerspectiveFilterCompanyStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchPerspectiveFilterCompanySuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterCompany: action.data
  }
}

const fetchPerspectiveFilterCompanyFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const fetchPerspectiveFilterActiveStart = (state, action) => {
  return { ...state, filterLoading: true }
}

const fetchPerspectiveFilterActiveSuccess = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    filterActive: action.data
  }
}

const fetchPerspectiveFilterActiveFailed = (state, action) => {
  return {
    ...state,
    filterLoading: false,
    message: action.errorMessage
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY_OPTIONS_START:
      return fetchCompanyStart(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_SUCCESS:
      return fetchCompanySuccess(state, action)
    case actionTypes.FETCH_COMPANY_OPTIONS_FAILED:
      return fetchCompanyFailed(state, action)
    case actionTypes.FETCH_PERSPECTIVE_START:
      return fetchPerspectiveStart(state, action)
    case actionTypes.FETCH_PERSPECTIVE_SUCCESS:
      return fetchPerspectiveSuccess(state, action)
    case actionTypes.FETCH_PERSPECTIVE_BY_ID_SUCCESS:
      return fetchPerspectiveByIdSuccess(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FAILED:
      return fetchPerspectiveFailed(state, action)
    case actionTypes.CLEAR_SELECTED_PERSPECTIVE_RECORD:
      return clearSelectedPerspectiveRecord(state, action)
    case actionTypes.CREATE_PERSPECTIVE_START:
      return createPerspectiveStart(state, action)
    case actionTypes.CREATE_PERSPECTIVE_SUCCESS:
      return createPerspectiveSuccess(state, action)
    case actionTypes.CREATE_PERSPECTIVE_FAILED:
      return createPerspectiveFailed(state, action)
    case actionTypes.UPDATE_PERSPECTIVE_START:
      return updatePerspectiveStart(state, action)
    case actionTypes.UPDATE_PERSPECTIVE_SUCCESS:
      return updatePerspectiveSuccess(state, action)
    case actionTypes.UPDATE_PERSPECTIVE_FAILED:
      return updatePerspectiveFailed(state, action)
    case actionTypes.DELETE_PERSPECTIVE_START:
      return deletePerspectiveStart(state, action)
    case actionTypes.DELETE_PERSPECTIVE_SUCCESS:
      return deletePerspectiveSuccess(state, action)
    case actionTypes.DELETE_PERSPECTIVE_FAILED:
      return deletePerspectiveFailed(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_COMPANY_START:
      return fetchPerspectiveFilterCompanyStart(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_COMPANY_SUCCESS:
      return fetchPerspectiveFilterCompanySuccess(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_COMPANY_FAILED:
      return fetchPerspectiveFilterCompanyFailed(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_START:
      return fetchPasswordPolicyStart(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_SUCCESS:
      return fetchPasswordPolicySuccess(state, action)
    case actionTypes.FETCH_PASSWORD_POLICY_OPTIONS_FAILED:
      return fetchPasswordPolicyFailed(state, action)
    case actionTypes.FETCH_LDAP_SERVER_OPTIONS_START:
      return fetchLdapServerStart(state, action)
    case actionTypes.FETCH_LDAP_SERVER_OPTIONS_SUCCESS:
      return fetchLdapServerSuccess(state, action)
    case actionTypes.FETCH_LDAP_SERVER_OPTIONS_FAILED:
      return fetchLdapServerFailed(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_OPTIONS_START:
      return fetchEmailServerStart(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_OPTIONS_SUCCESS:
      return fetchEmailServerSuccess(state, action)
    case actionTypes.FETCH_EMAIL_SERVER_OPTIONS_FAILED:
      return fetchEmailServerFailed(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_START:
      return fetchPerspectiveFilerStart(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_SUCCESS:
      return fetchPerspectiveFilerSuccess(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_FAILED:
      return fetchPerspectiveFilerFailed(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_ACTIVE_START:
      return fetchPerspectiveFilterActiveStart(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_ACTIVE_SUCCESS:
      return fetchPerspectiveFilterActiveSuccess(state, action)
    case actionTypes.FETCH_PERSPECTIVE_FILTER_ACTIVE_FAILED:
      return fetchPerspectiveFilterActiveFailed(state, action)
    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}

export default reducer
